export default __webpack_public_path__ + "static/image/pattern.c2366c76.jpg";